// extracted by mini-css-extract-plugin
module.exports = {"feedback-title":"nudge-owner-modal_feedback-title__dBEJt","radio-group":"nudge-owner-modal_radio-group__5PQXL","message-input":"nudge-owner-modal_message-input__WUtKz"};